import CheckLoading, { CheckLoadingProps } from "../base/CheckLoading";
import CheckNotAuthenticated from "../base/CheckNotAuthenticated";

interface PageAuthenticatedLoadingProps {
  topbar?: React.ReactNode;
  loading: CheckLoadingProps;
}
const PageAuthenticatedLoading = ({ topbar, loading }: PageAuthenticatedLoadingProps) => {
  // console.log(`PageAuthenticatedLoading.states: ${JSON.stringify(loading.states)}`);
  const content = () => {
    return <CheckLoading
      states={loading.states}
      content={loading.content}
      error={loading.error}
      retry={loading.retry} />;
  };

  return <>
    {topbar}
    <CheckNotAuthenticated content={content} />
  </>;
};

export default PageAuthenticatedLoading;